export const documentationCategories = [
  {
    id: 'training-compliance',
    title: 'Guidance & Compliance',
    description: 'Orientation guidance and audit-ready checklists for ISET Coordinators and other PATH staff.',
    items: [
      {
        id: 'iset-orientation-2025',
        title: 'ISET Orientation Guidance Modules (2025-2026)',
        runtimeId: 'training-modules-2025',
        sourcePath: 'docs/training/TRAINING_MODULES_September_2025_extracted.md',
        sourceNote: 'Reference guidance compiled from internal program materials; not a replacement for formal training.',
        summary: [
          'Orientation to the NWAC ↔ ESDC contribution agreement, funding streams (EI/CRF), and program mandate.',
          'Eligibility and documentation expectations for case managers, including ARMS usage and audit readiness.',
          'Overview of intervention pathways (training, wage subsidy, JCP, SEB) and case management cadence.'
        ]
      },
      {
        id: 'compliant-file-checklist',
        title: 'Compliant File Checklist',
        sourcePath: 'docs/training/compliance file list.txt',
        sourceNote: 'Checklist stored under docs/training; copy or publish externally if it must be user-facing.',
        summary: [
          'One-page checklist for audit-ready client files: EI consent/verification, IDs, Indigenous self-declaration.',
          'Includes band funding/denial letters, educational institution proof, and consent forms.',
          'Covers financial overview, income/expense verification, attendance forms for living allowances.'
        ]
      }
    ],
  },
];

export default documentationCategories;
